// @flow
import React from 'react';
import {Link} from 'react-router-dom';

import {
    ALARM__24,
    ALERT_WARNING__24,
    SVGIcon,
} from '../../../atoms/baseline/baseline';

/* atoms */
import {Typography} from '../../../atoms/Typography/Typography';

/* molecule */
import {Card} from '../../../molecules/Card/Card';
import {CardContent} from '../../../molecules/CardContent/CardContent';
import {ImageWithStatus} from '../../../molecules/ImageWithStatus/ImageWithStatus';

/* utils */
import translate from '../../../../utils/translations';
import {tripSelected, TRIPS} from '../../../../utils/edapUtils';
import {
    getDisplayLocation,
    getDisplayStayDates,
    getPaymentStatus,
    getTripStatusLabel,
} from '../../myTripUtils';

import './TripCard.less';

import type {TripDetails} from '../TripCards';

import {PROPERTY_IMAGE_PLACEHOLDER} from '../../../constants';

type TripCardProps = {
    trip: TripDetails,
    translations: Object,
    locale: string,
};

export const TripCard = (props: TripCardProps) => {
    const {locale, translations, trip} = props;
    const status = getTripStatusLabel(trip);
    const {booking, conversationId} = trip;
    const {listing, uuid} = booking || {};
    const photos = listing?.photos || [];
    const propertyImage = photos[0]?.uri;
    const displayLocation = getDisplayLocation(trip);
    const displayStayDates = getDisplayStayDates({locale, trip});
    const {isPaymentOverdue, paymentText} = getPaymentStatus(trip) || {};
    const paymentDueDateIcon = isPaymentOverdue ? ALERT_WARNING__24 : ALARM__24;
    const paymentDueDateIconClass = `DuePaymentDate__paymentDueDate--icon ${
        isPaymentOverdue ? 'text-danger' : 'text-default'
    }`;
    const handleTripCardClick = () => {
        tripSelected({
            actionLocation: TRIPS,
            reservationUUID: uuid,
        });
    };
    const cardWrapperTagNameProps = {
        onClick: handleTripCardClick,
        to: {
            pathname: `/traveler/th/inbox/conversation/${conversationId}/details`,
            state: {backUrl: '/traveler/th/bookings'},
        },
    };
    const paymentDueDateText = (paymentValue) => {
        return `${translate(
            translations,
            'trav-dash/trav-home',
            'messages',
            'th.inbox.conversation.quoteSummary.payment',
            ['']
        ).trim()}: ${paymentValue}`;
    };
    const DuePaymentDate = ({paymentValue, paymentIcon, paymentIconClass}) => (
        <div className="DuePaymentDate__paymentDueDate">
            <SVGIcon
                className={paymentIconClass}
                inlineFlex
                markup={paymentIcon}
            />
            <Typography
                className="DuePaymentDate__paymentDueDate--text"
                content={paymentDueDateText(paymentValue)}
                TagName="span"
            />
        </div>
    );
    const getCardContent = () => (
        <CardContent
            cardHeading={displayLocation}
            subHeading={displayStayDates}
        >
            {paymentText && (
                <DuePaymentDate
                    paymentIcon={paymentDueDateIcon}
                    paymentIconClass={paymentDueDateIconClass}
                    paymentValue={paymentText}
                />
            )}
        </CardContent>
    );
    const getImageWithStatus = () => (
        <ImageWithStatus
            imageUri={propertyImage}
            layout="vertical"
            status={status}
        />
    );

    return (
        <Card
            bottom={getCardContent()}
            cardWrapperTagName={Link}
            cardWrapperTagNameProps={cardWrapperTagNameProps}
            leftTagName="div"
            topLeft={getImageWithStatus()}
        />
    );
};

TripCard.defaultProps = {
    trip: {
        booking: {
            listing: {
                photos: [
                    {
                        uri: PROPERTY_IMAGE_PLACEHOLDER,
                    },
                ],
            },
        },
        stayDisplayStatus: {
            description: '',
        },
    },
    translations: {},
};
